import axios from "axios";

export async function getDoctorInfo(nice_id) {
  let bodyFormData = new FormData();
  bodyFormData.set("nice_id", nice_id);
  let response = await axios({
    method: "post",
    data: bodyFormData,
    url: window.server + "/turn/doctor",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
}

export async function checkLogin() {
  let bodyFormData = new FormData();
  let token = localStorage.getItem("token");
  bodyFormData.set("token", token);
  bodyFormData.set("type", "reseller");
  let response = await axios({
    method: "post",
    data: bodyFormData,
    url: window.server + "/reseller/login/check",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
}

// convert 12548 to "12,548" and also prevent reading non numeric values
export function separateByThreeDigits(inputValue = "") {
  return parseFloat(
    toEnglishDigits(inputValue.toString()).replace(/[^\d]+/gi, "") || 0
  ).toLocaleString("en-US");
}

export function toEnglishDigits(input = "") {
  const persianDigits = {
    "۰": 0,
    "۱": 1,
    "۲": 2,
    "۳": 3,
    "۴": 4,
    "۵": 5,
    "۶": 6,
    "۷": 7,
    "۸": 8,
    "۹": 9,
  };

  let convertedInput = "";

  for (let char of input) {
    if (Object.keys(persianDigits).includes(char)) {
      convertedInput += persianDigits[char];
    } else {
      convertedInput += char;
    }
  }

  return convertedInput;
}
